import { IonIcon, IonSelect, IonSelectOption } from "@ionic/react";
import { schoolOutline } from "ionicons/icons";
import { useRef, useState } from "react";
import { allSubjects } from "../../data/subjects";

function SelectExam({ handleExamChange }) {
  const [subjectKey, setSubjectKey] = useState();
  const [groupLabel, setGroupLabel] = useState();
  const [chapterNumber, setChapterNumber] = useState();

  const firstSelect = useRef(null);
  const secondSelect = useRef(null);
  const thirdSelect = useRef(null);

  const resetSelection = () => {
    setSubjectKey(undefined);
    setGroupLabel(undefined);
    setChapterNumber(undefined);
  };

  const startSelection = () => {
    resetSelection();
    firstSelect.current?.open();
  };

  const handleSubjectChange = (e) => {
    const key = e.detail.value;
    setSubjectKey(key);
    secondSelect.current?.open();
  };

  const handleGroupChange = (e) => {
    const label = e.detail.value;
    setGroupLabel(label);
    thirdSelect.current?.open();
  };

  const handleChapterChange = (e) => {
    const value = e.detail.value;

    if (Number(value)) {
      setChapterNumber(value);
      handleExamChange(groupLabel, value);
    } else {
      handleExamChange(value);
    }
  };

  const handleCancel = () => {
    resetSelection();
  };

  const groups = subjectKey ? allSubjects[subjectKey] : [];
  const chapters = groupLabel
    ? groups
        .find((g) => g.label === groupLabel)
        .units.flatMap((u) => u.chapters)
    : [];

  return (
    <div>
      <div onClick={startSelection} className="post-form-footer-button">
        <IonIcon icon={schoolOutline} className="red-icon" />
        <span style={{ fontWeight: "bold" }}>Quiz</span>
      </div>

      <IonSelect
        ref={firstSelect}
        interface="action-sheet"
        placeholder="Choose Subject"
        onIonChange={handleSubjectChange}
        onIonCancel={handleCancel}
        style={{ display: "none" }}
      >
        {Object.keys(allSubjects).map((key) => (
          <IonSelectOption key={key} value={key}>
            {key}
          </IonSelectOption>
        ))}
      </IonSelect>

      <IonSelect
        ref={secondSelect}
        interface="action-sheet"
        placeholder="Choose Group"
        onIonChange={handleGroupChange}
        onIonCancel={handleCancel}
        value={groupLabel}
        style={{ display: "none" }}
      >
        {groups.map((grp) => (
          <IonSelectOption key={grp.label} value={grp.label}>
            {grp.label}
          </IonSelectOption>
        ))}
      </IonSelect>

      <IonSelect
        ref={thirdSelect}
        interface="action-sheet"
        placeholder="Choose Chapter"
        onIonChange={handleChapterChange}
        onIonCancel={handleCancel}
        value={chapterNumber}
        style={{ display: "none" }}
      >
        {chapters.map((ch, i) => (
          <IonSelectOption key={ch.text} value={ch.value ? ch.value : i + 1}>
            {ch.text}
          </IonSelectOption>
        ))}
      </IonSelect>
    </div>
  );
}

export default SelectExam;

